import { memo } from 'react';
import Layout from '@/components/Layout';
import SearchForm from '@/components/SearchForm';
import SearchResultsHeader from '@/components/search/SearchResultsHeader';
import SearchResultsStatusBanner from '@/components/search/SearchResultsStatusBanner';
import SearchResultsGrid from '@/components/search/SearchResultsGrid';
import { useSearchResultsLogic } from '@/hooks/useSearchResultsLogic';
const SearchResults = memo(() => {
  const {
    filteredProperties,
    isAnyLoading,
    hasErrors,
    refetchAll,
    guests,
    checkin,
    checkout
  } = useSearchResultsLogic();
  return <Layout>
      {/* Search Form */}
      <section className="py-3 bg-white shadow-sm border-b border-gray-100">
        <div className="max-w-7xl mx-auto px-2 sm:px-6 lg:px-8">
          <SearchForm showSimplified={true} />
        </div>
      </section>

      {/* Results */}
      <section className="pt-8 pb-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Only show header when no properties are found and not loading */}
          {!isAnyLoading && filteredProperties.length === 0 && <SearchResultsHeader filteredPropertiesCount={filteredProperties.length} guests={guests} checkin={checkin} checkout={checkout} />}
          
          <SearchResultsStatusBanner isAnyLoading={isAnyLoading} hasErrors={hasErrors} refetchAll={refetchAll} />

          <SearchResultsGrid filteredProperties={filteredProperties} hasErrors={hasErrors} refetchAll={refetchAll} checkin={checkin} checkout={checkout} />
        </div>
      </section>
    </Layout>;
});
SearchResults.displayName = 'SearchResults';
export default SearchResults;